import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { Associado } from '@/models/Associado'
import Swal from 'sweetalert2'
import { associadoTransformer } from '@/utils/transformers'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'
export const LOAD_ROLES = 'LOAD_ROLES'
export const LOAD_EVENTOS = 'LOAD_EVENTOS'
export const LOAD_ASSOCIADO = 'LOAD_ASSOCIADO'

const getDefaultState = () => {
  return {
    picked: '',
    telefones: [
      { tipo: 'Comercial', format: 'com', title: 'Telefone', required: true },
    ],
    roles: [],
    loading: true,
    loadedEventos: [],
    loadedAssociado: [],
    isEditing: false,
    dialog: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [LOAD_EVENTOS] ({ commit }, { id }) {
    await api.listEntidade('evento').then(response => {
      let eventos
      if (id) {
        eventos = response.filter(evento => evento.classe === 'S' && (evento.tipo_calculo === 1 || evento.tipo_calculo === 2 || evento.tipo_calculo === 3))
      } else {
        eventos = response.filter(evento => evento.status === 1 && evento.classe === 'S' && (evento.tipo_calculo === 1 || evento.tipo_calculo === 2 || evento.tipo_calculo === 3))
      }
      eventos.sort((A, B) => {
        const a = A.descricao.toLowerCase()
          .toLowerCase()
          .replace(/[àáâãäå]/, 'a')
          .replace(/[èéêë]/, 'e')
          .replace(/[ìíîï]/, 'i')
          .replace(/[òóôõö]/, 'o')
          .replace(/[ùúûü]/, 'u')
          .replace(/[ç]/, 'c')
          .replace(/[^a-z0-9]/gi, '')

        const b = B.descricao.toLowerCase()
          .toLowerCase()
          .replace(/[àáâãäå]/, 'a')
          .replace(/[èéêë]/, 'e')
          .replace(/[ìíîï]/, 'i')
          .replace(/[òóôõö]/, 'o')
          .replace(/[ùúûü]/, 'u')
          .replace(/[ç]/, 'c')
          .replace(/[^a-z0-9]/gi, '')
        return a < b ? -1 : a > b ? 1 : 0
      })
      commit(SET_STATE, { loadedEventos: eventos })
    })
  },
  async [LOAD_ASSOCIADO] ({ commit }) {
    await api.listEntidade('associado/mini').then(response => {
      let associado = response.filter(assoc => assoc.status === 1)
      associado = associado.map(({ cpf, cnpj, razao_social, nome, ...associado }) => ({
        ...associado,
        cpf_cnpj: cpf || cnpj,
        nome_razao_social: nome || razao_social,
      }))
      associado.sort((A, B) => {
        const a = A.nome_razao_social.toLowerCase()
          .replace(/[àáâãäå]/, 'a')
          .replace(/[èéêë]/, 'e')
          .replace(/[ìíîï]/, 'i')
          .replace(/[òóôõö]/, 'o')
          .replace(/[ùúûü]/, 'u')
          .replace(/[ç]/, 'c')
          .replace(/[^a-z0-9]/gi, '')

        const b = B.nome_razao_social.toLowerCase()
          .replace(/[àáâãäå]/, 'a')
          .replace(/[èéêë]/, 'e')
          .replace(/[ìíîï]/, 'i')
          .replace(/[òóôõö]/, 'o')
          .replace(/[ùúûü]/, 'u')
          .replace(/[ç]/, 'c')
          .replace(/[^a-z0-9]/gi, '')
        return a < b ? -1 : a > b ? 1 : 0
      })
      associado.forEach(element => {
        element.nome_razao_social = '(' + element.codigo + ')  ' + element.nome_razao_social
      })
      commit(SET_STATE, { loadedAssociado: associado })
    })
  },
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit('SET_STATE', { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new Associado() }, { root: true })
    await dispatch(LOAD_ROLES)
    await dispatch(LOAD_EVENTOS, { id })
    await dispatch(LOAD_ASSOCIADO)
    if (id) {
      commit(SET_STATE, { isEditing: true, dialog: false })
      await api.getEntidade('associado', id).then(response => {
        commit(SET_STATE, { picked: response.data[0].pessoaFis ? 'fisica' : 'juridica', loading: false })
        dispatch('form/BOOTSTRAP_FORM', { model: new Associado(associadoTransformer(response.data[0], state.telefones)) }, { root: true })
      })
    } else {
      commit(SET_STATE, { dialog: true, loading: false, isEditing: false })
    }
  },
  async [LOAD_ROLES] ({ dispatch, commit }) {
    await api.getEntidade('role', 4).then(
      response => {
        const roles = response.data
        commit(SET_STATE, { roles })
      },
    )
  },
  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    Swal.fire({
      title: 'Cadastrando Associado!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data }
        const [day, month, year] = form.data_ingresso.split('/')
        form.data_ingresso = year + '-' + month + '-' + day
        form.role_id = form.role
        form.status = form?.status ? form.status : 0
        form.pessoaFis = state.picked === 'fisica'
        const evento = form.eventos.map(row => {
          console.log(row)
          return {
            evento_id: row.evento.id,
            valor_evento: row.valor_evento,
            associado_matriz_id: row.associado_matriz ? row.associado_matriz.id : null,
          }
        })
        form.eventos = evento;
        (() => {
          return state.isEditing
            ? api.salvarEntidade(form, 'associado', form.id)
            : api.cadastrarEntidade(form, 'associado')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Associado atualizado com sucesso!'
                : 'Associado cadastrado com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })
            dispatch('associados/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/associados`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: error.errors ? error.errors : error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
